import { z } from "zod";

/// URL state for the Workspace dashboard (S3): the active tab, the Overview
/// time range, and the Insights-tab triage filters. Keeping the insight
/// filters here (rather than local component state) makes a filtered triage
/// view deep-linkable + survive refresh, the same as People/Feedback filters.
export const workspaceDashboardSearchSchema = z
  .object({
    tab: z.enum(["overview", "brief", "insights"]).optional(),
    range: z.enum(["7d", "30d"]).optional(),
    /// Workspace-brief audience switcher (Owner / People Ops lens). In the
    /// URL so a brief link is shareable; falls back to people_ops for a
    /// missing or unrecognised value the same way `comparison.route.search`
    /// falls back `metric`.
    briefAudience: z.enum(["people_ops", "owner"]).catch("people_ops"),
    insightAudience: z.enum(["manager", "people_ops", "owner"]).optional(),
    insightScope: z.enum(["workspace", "department", "membership"]).optional(),
    insightStatus: z.enum(["generated", "shown", "reviewed", "dismissed", "expired"]).optional(),
    insightSeverity: z.enum(["low", "medium", "high", "critical"]).optional(),
    /// Insight opened in the detail sheet. In the URL so a triaged insight is
    /// shareable and the action-detail "source insight" link can deep-link it.
    insightId: z.string().optional(),
  })
  .strict();

export type WorkspaceDashboardSearch = z.infer<typeof workspaceDashboardSearchSchema>;
